import { render, staticRenderFns } from "./ChamCongItemTrongPhieuSuaChua.vue?vue&type=template&id=7bbb0976&scoped=true"
import script from "./ChamCongItemTrongPhieuSuaChua.vue?vue&type=script&lang=js"
export * from "./ChamCongItemTrongPhieuSuaChua.vue?vue&type=script&lang=js"
import style0 from "./ChamCongItemTrongPhieuSuaChua.vue?vue&type=style&index=0&id=7bbb0976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbb0976",
  null
  
)

export default component.exports